<template>
  <div class="replacementmonthlystatistics__report__view">    
    <div class="reports__subheader">
      <submit-panel @submit="registerUser" text="Opret bruger" v-if="hasEditRights">
      </submit-panel>
    </div>
    <b-table :data="appUsers"
             :loading="loading"
             @click="onRowClick"
             hoverable>

      <b-table-column field="number"
                      label="Nr."
                      searchable
                      v-slot="props">
        {{ props.row.number }}
      </b-table-column>

      <b-table-column field="password"
                      label="Password"
                      searchable
                      v-if="isPasswordVisible"
                      v-slot="props">
        {{ props.row.password }}
      </b-table-column>

      <b-table-column field="name"
                      label="Navn"
                      searchable
                      v-slot="props">
        {{ props.row.name }}
      </b-table-column>

      <b-table-column field="phoneWork"
                      label="Tlf for."
                      searchable
                      v-slot="props">
        {{ props.row.phoneWork }}
      </b-table-column>

      <b-table-column field="phonePrivate"
                      label="Tlf privat"
                      searchable
                      v-slot="props">
        {{ props.row.phonePrivate }}
      </b-table-column>

      <b-table-column field="mobilePhone"
                      label="Tlf mobil"
                      searchable
                      v-slot="props">
        {{ props.row.mobilePhone }}
      </b-table-column>

      <b-table-column field="email"
                      label="Email"
                      searchable
                      v-slot="props">
        {{ props.row.email }}
      </b-table-column>
      <b-table-column field="region"
                      label="Region"
                      searchable
                      v-slot="props">
        {{ props.row.region }}
      </b-table-column>

      <b-table-column field="circleName"
                      label="Kreds"
                      searchable
                      v-slot="props">
        {{ props.row.circleName }}
      </b-table-column>

      <b-table-column field="groupName"
                      label="Grp"
                      searchable
                      v-slot="props">
        {{ props.row.groupName }}
      </b-table-column>

      <b-table-column>
        <span>
          <b-icon pack="fas"
                  icon="angle-right"></b-icon>
        </span>
        <template v-slot:header>
          <div @click="registerUser"
               v-if="hasEditRights"
               class="register-user">
            <b-icon pack="fas"
                    icon="plus"></b-icon>
          </div>
        </template>
      </b-table-column>

    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../enums/APISTATE";
import SubmitPanel from '@/components/report/SubmitPanel.vue';

export default {
  name: "users-view",
  components: {SubmitPanel},
  data: () => ({
    adminNumbers: ['1016', '1010', '1011']
  }),
  async mounted() {
    await this.loadAppUsers();
  },
  computed: {
    ...mapGetters("appUsers", ["appUserApiState", "appUsers"]),
    ...mapGetters(["currentUser", "isAdmin", "hasEditRights"]),
    loading() {
      return this.appUserApiState !== ApiState.LOADED;
    },
    isPasswordVisible() {
      return this.adminNumbers.find(f => f === this.currentUser.number);
    },
  },
  methods: {
    ...mapActions("appUsers", ["loadAppUsers"]),
    onRowClick(row) {
      this.$router.push(`/configuration/users/${row.id}/edit`);
    },
    registerUser() {
      this.$router.push("/configuration/users/new");
    },
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
